import { gql } from '@apollo/client';

const CREATE_ACCESS_RESOURCE_EVENT = gql`
  mutation createAccessResourceEvent($data: AccessResourceEventCreateInput!) {
    createAccessResourceEvent(data: $data)
  }
`;

export default CREATE_ACCESS_RESOURCE_EVENT;
